export const DEFAULT_QUICK_PROMPTS = [
  'How do I create an approval request?',
  'How do I create a Purchase Order?',
  'How do I create a Bill of Materials (BOM)?',
] as const;

export type HelpAgentQuickPromptList = readonly string[];
